import React, { Component } from 'react';

import './NoMatchScreen.css';

import { Layout } from 'antd';
const { Content } = Layout;

class NoMatchScreen extends Component {
  render() {
    return (
      <Content style={{ margin: '24px 16px 0' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h1>404</h1>
          <p>Page not found!</p>
        </div>
      </Content>
    );
  }
}

export default NoMatchScreen;



// WEBPACK FOOTER //
// ./src/screens/NoMatchScreen.js